<div class="text-center">
    <div class="eprx--block__footer" [ngClass]="(IsPageFrm === 'prevoiusRefills') ? 'mt-3':''">
        <span></span>
        <i class="fa fa-file"></i><br/>
           {{TextDisplay}}
    </div>
</div>